import { render, staticRenderFns } from "./MenuProcessoVisualizacao.vue?vue&type=template&id=5be43b64&scoped=true"
import script from "./MenuProcessoVisualizacao.vue?vue&type=script&lang=js"
export * from "./MenuProcessoVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./MenuProcessoVisualizacao.vue?vue&type=style&index=0&id=5be43b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be43b64",
  null
  
)

export default component.exports